export enum ELanguage {
  ENGLISH = 'en-US',
  KINYARWANDA = 'rw',
  FRENCH = 'fr'
}
